import { render, staticRenderFns } from "./ProjetForm.vue?vue&type=template&id=01d2fd48&scoped=true&lang=true"
import script from "./ProjetForm.vue?vue&type=script&lang=js"
export * from "./ProjetForm.vue?vue&type=script&lang=js"
import style0 from "./ProjetForm.vue?vue&type=style&index=0&id=01d2fd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2fd48",
  null
  
)

export default component.exports